var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-phone-count-line"},[(_vm.$scopedSlots.count)?_c('span',{staticClass:"base-phone-count-line__count"},[_vm._t("count")],2):_vm._e(),_c('div',{staticClass:"base-phone-count-line__actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }